<template>
  <td
    @click="action()"
    :class="specialClass"
    :style="[specialStyle]"
    @dblclick="edit"
  >
    <div v-html="label" class="pd-0 mg-0"></div>
  </td>
</template>

<script>
import Axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import config from "@/config.js";
import { mapState } from "vuex";
import Vue from "vue";

import ProcessService from "@/services/ProcessService.js";
import { EventBus } from "@/events/EventBus.js";
import { labels } from "@/labels/labels.processes";

export default {
  props: ["column", "data", "fieldInfo", "opennedBy"],
  data() {
    return {
      objects: [
        "customer",
        "exporter",
        "manufacturer",
        "customBroker",
        "shipowner",
		"destinationPort",
        "account",
        "freightForwarder",
        "conveyor",
        "generalWarehouse",
      ],
      dates: [
        "originalsDocumentsDate",
        "originalsDocumentsDateSolved",
        "originalsBillOfLadingDate",
        "originalsBillOfLadingDateSolved",
        "originalsInvoiceDate",
        "originalsInvoiceDateSolved",
        "originalsPackingListDate",
        "originalsPackingListDateSolved",
        "billingNFsDate",
        "billingNFsDateSolved",
        "billingNFsEmissionDateSolved",
        "billingBillCustomerDate",
        "billingEmailDate",
        "billingEmailDateSolved",
        "billingSendDate",
        "billingCustomBrokerFinishDate",
        "billingDataConferenceDate",
        "datesEstimatedGoodsReadinesDate",
        "datesETD",
        "datesETA",
        "customerExpectedReceiptDate",
        "datesEstimatedCustomerDeliverDate",
        "datesGoodsReadinesDate",
        "datesDepartureDate",
        "datesArrivalDate",
        "datesGoodsPresenceDate",
        "datesInspectionOfTheDIDate",
        "datesInspectionOfTheDuimpDate",
        "datesGoodsLoadingDate",
        "datesCustomerDeliverDate",
        "datesInspectionMAPADate",
        "datesInspectionMAPADateSolved",
        "datesReleaseMAPADate",
        "datesReleaseMAPADateSolved",
        "datesLinkInTheEnclosureDate",
        "datesLinkInTheEnclosureDateSolved",
        "datesBillOfLadingReleaseDate",
        "datesSiscargaDate",
        "datesIsThereDTCDTATransfer",
        "datesDTCDTA",
        "datesThereIsDesova",
        "datesEnclosureBillingDate",
        "datesComexDate",
        "stepInsurance",
        "stepInsuranceSolved",
        "stepInsuranceValue",
        "stepCashRequest",
        "stepSpreadsheet",
        "created",
        "documentsSentForExchange",
		"cashRequestDoneDate",
		"datesEstimatedCargoCollectDate",
		"datesCargoCollectDate",
		"financialClosingDebitDueDate",
		"afrmmPaymentDate",
		"parameterizationDate",
      ],
	  money: [
		"integrationAFRMMValue",
	  ],
	  datetimes: [
		"billingNFsEmissionDate",
      ],
      booleans: [
        "datesIsThereDTCDTATransfer",
        "billingBillCustomerDateSolved",
        "hasInvoices",
      ],
    };
  },
  directives: {},
  computed: {
    ...mapState({
      processes: (state) => state.ProcessStore.processes,
      socket: (state) => state.ProcessStore.socket,
      credentials: (state) => state.credentials,
    }),
    label() {
      const contentDefault = '<i class="icon ion-ios-close tx-white "></i>';

      if (this.column === "hasInvoices") {
        if (this.data.hasInvoices) {
          return `
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="var(--green)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-circle-check"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="m9 12 2 2 4-4" />
            </svg>
          `;
        }
        if (!this.data.hasInvoices) {
          return `
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="var(--red)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-circle-x"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="m15 9-6 6" />
              <path d="m9 9 6 6" />
            </svg>
          `;
        }
      }

      if (this.column == "identification") {
        let content = "";

        if (this.opennedBy !== undefined && this.opennedBy !== null) {
          content += `<span class="tx-14 tx-black tx-semibold uppercase" data-title="${this.opennedBy} está editando"><i class="fa fa-users tx-danger mg-t-0 mg-r-5"></i></span>`;
        }

        if (this.data.reminder && this.data.urgent === true) {
          content += '<i class="fa fa-flag tx-primary mg-t-0 mg-r-5"></i>';
          content += `<span class="tx-14 tx-white tx-semibold uppercase" style="z-index: 0 !important;" data-title="${
            this.data.reminder
          }">${this.getTypeOfProcessReferenceByProcess(this.data)}</span>`;
        } else if (this.data.reminder) {
          content += '<i class="fa fa-flag tx-primary mg-t-0 mg-r-5"></i>';
          content += `<span class="tx-14 tx-black tx-semibold uppercase" style="z-index: 0 !important;" data-title="${
            this.data.reminder
          }">${this.getTypeOfProcessReferenceByProcess(this.data)}</span>`;
        } else if (this.data.urgent === true) {
          content += `<span class="tx-14 tx-semibold uppercase tx-white">${this.getTypeOfProcessReferenceByProcess(
            this.data
          )}</span>`;
        } else {
          content += `<span class="tx-14 tx-black tx-semibold uppercase">${this.getTypeOfProcessReferenceByProcess(
            this.data
          )}</span>`;
        }

        return content;
      }
      if (this.column == "alerts") {
        let content = "";

        // if (this.data.hasWithoutOperationalTeamAlert) {
        //   content = content + `<span class="badge badge-danger p-2" data-title="Cliente sem time operacional de ${this.data.typeOfProcess}">CST</span>`;
        // }

        if (this.data.hasRadarAlert) {
          content +=
            '<span class="tx-16 tx-center mb-1" style="z-index: 1;" data-title="Alerta de Radar"><i class="icon ion-ionic text-dark"></i></span>';
        }

        if (this.data.hasTFAAlert) {
          content +=
            '<span class="tx-16 tx-center tx-danger" style="z-index: 1;" data-title="Ausência do TFA"><i class="icon ion-clipboard text-dark"></i></span> </br>';
        }

        return content;
      }
      if (this.column == "status") {
        if (this.data[this.column] !== null && this.data[this.column] !== "") {
          return `<span class="tx-normal">${this.data[this.column]}</span>`;
        }
      } else if (this.column == "operationStatus") {
        if (this.data[this.column] === null || this.data[this.column] === "") {
          return "";
        }
        if (this.data.urgent === true) {
          return (
            `${'<span class="tx-normal">' + '<span class="tx-white">'}${
              this.data[this.column]
            }</span>` + "</span>"
          );
        }
        return `<span class="tx-normal">${this.data[this.column]}</span>`;
      } else if (this.column == "incoterm") {
        if (this.data[this.column] !== null) {
          return `<div class="tx-center">${this.data[this.column]}</div>`;
        }
        return '<div class="tx-center"><i class="tx-14 fa fa-exclamation"></i></div>';
      } else if (this.column == "revenuesReleaseBLAWBState") {
        let revenuesReleaseBLAWBStateElement = "";

        revenuesReleaseBLAWBStateElement += `<span>${
          this.data.revenuesReleaseBLAWBDate
            ? moment(this.data.revenuesReleaseBLAWBDate).format("DD/MM/YY")
            : "-"
        }</span><br/>`;

        if (this.data.revenuesReleaseBLAWBState) {
          revenuesReleaseBLAWBStateElement +=
            '<span class="text-success mt-3">Enviado</span>';
        } else {
          revenuesReleaseBLAWBStateElement +=
            '<span class="text-danger mt-3">Pendente</span>';
        }

        return `<div class="text-center">${revenuesReleaseBLAWBStateElement}</div>`;
      } else if (this.column == "revenuesStorageState") {
        let revenuesStorageStateElement = "";

        revenuesStorageStateElement += `<span>${
          this.data.revenuesStorageDate
            ? moment(this.data.revenuesStorageDate).format("DD/MM/YY")
            : "-"
        }</span><br/>`;

        if (this.data.revenuesStorageState) {
          revenuesStorageStateElement +=
            '<span class="text-success mt-3">Enviado</span>';
        } else {
          revenuesStorageStateElement +=
            '<span class="text-danger mt-3">Pendente</span>';
        }

        return `<div class="text-center">${revenuesStorageStateElement}</div>`;
      } else if (this.column == "revenuesTransportState") {
        let revenuesTransportStateElement = "";

        revenuesTransportStateElement += `<span>${
          this.data.revenuesTransportDate
            ? moment(this.data.revenuesTransportDate).format("DD/MM/YY")
            : "-"
        }</span><br/>`;

        if (this.data.revenuesTransportState) {
          revenuesTransportStateElement +=
            '<span class="text-success mt-3">Enviado</span>';
        } else {
          revenuesTransportStateElement +=
            '<span class="text-danger mt-3">Pendente</span>';
        }

        return `<div class="text-center">${revenuesTransportStateElement}</div>`;
      } else if (this.column == "revenuesOtherExpenses") {
        if (this.data.revenuesOtherExpenses) {
          let revenuesOtherExpensesElement = "";

          revenuesOtherExpensesElement += `<span>${
            this.data.revenuesOtherExpensesDate
              ? moment(this.data.revenuesOtherExpensesDate).format("DD/MM/YY")
              : "-"
          }</span><br/>`;

          if (this.data.revenuesOtherExpensesState) {
            revenuesOtherExpensesElement +=
              '<span class="text-success mt-3">Enviado</span>';
          } else {
            revenuesOtherExpensesElement +=
              '<span class="text-danger mt-3">Pendente</span>';
          }

          return `<div class="text-center">${revenuesOtherExpensesElement}</div>`;
        }
        return '<div class="tx-center">-</di>';
      } else if (this.column == "typeOfBoarding") {
        if (this.data.wayOfTransport === "MARITIMA") {
          return `<div class="tx-center">${this.data[this.column]}</div>`;
        }
        if (this.data.wayOfTransport === "AEREA") {
          return '<div class="tx-center"><i class="tx-18-force fa fa-plane text-danger"></i></div>';
        }
        if (this.data.wayOfTransport === "RODOVIARIA") {
          return '<div class="tx-center"><i class="tx-16-force fa fa-truck tx-teal"></i></div>';
        }
        if (
          this.data[this.column] === null ||
          this.data[this.column] === "NENHUM"
        ) {
          return '<div class="tx-center"><i class="tx-16-force fa fa-exclamation text-danger"></i></div>';
        }

        return `<div class="tx-center">${this.data[this.column]}</div>`;
      } else if (this.column == "diChannel") {
		let diChannel = this.data.diChannel || "";
		if (this.data.duimp) {
			diChannel = this.data.duimpChannel || "";
		} 
        if (diChannel === "VERDE") {
          return `<span class="tx-center tx-normal uppercase" style="text-align: center; background: #00A068; color: white; padding: 4px; border: 1px; border-radius: 5px;">${diChannel}</span>`;
        }
        if (diChannel === "AMARELO") {
          return `<span class="tx-center tx-normal uppercase" style="text-align: center;background: #F49917; color: white; padding: 4px; border: 1px; border-radius: 5px;">${diChannel}</span>`;
        }
        if (diChannel === "CINZA") {
          return `<span class="tx-center tx-normal uppercase" style="text-align: center;background: #868ba1; color: white; padding: 4px; border: 1px; border-radius: 5px;">${diChannel}</span>`;
        }
        if (diChannel === "VERMELHO") {
          return `<span class="tx-center tx-normal uppercase" style="text-align: center;background: #dc3545; color: white; padding: 4px;  border: 1px; border-radius: 5px;">${diChannel}</span>`;
        }

	  } else if(this.column == "team") {

		if (this.data.teamName) {
			return this.data.teamName;
		} else if (this.data.team?.name) {
			return this.data.team.name;
		} else if (this.data.typeOfProcess === "CONTA_E_ORDEM") {
			return this.data.customer?.team?.name || this.data.customerTeamName || "";
		} else if (this.data.typeOfProcess === "ASSESSORIA") {
			return this.data.customer?.teamAdvisory?.name || this.data.customerTeamAdvisoryName || "";
		} else if (this.data.typeOfProcess === "ENCOMENDA") {
			return this.data.customer?.teamOrder?.name || this.data.customerTeamOrderName || "";
		} 

	  } else if(this.column == "customsTeam") {
		if (this.data?.customsTeamName) {
			return this.data.customsTeamName;
		} else if (this.data?.customsTeam?.name) {
			return this.data.customsTeam.name;
		} else {
			return "N/I";
		}
	  } else if (this.column == "placeOfLoading") {
		let placeOfLoading = this.data.placeOfLoading || "";
		if (this.data.placeOfLoadingEntity?.name) {
			placeOfLoading = this.data.placeOfLoadingEntity?.name || "";
		} else if (this.data.placeOfLoadingEntity) {
			placeOfLoading = this.data.placeOfLoadingEntity|| "";
		}
		return placeOfLoading;
	  } else if (this.column == "vehicle") {
		let vehicle = this.data.vehicle || "";
		if (this.data.vehicleEntity?.name) {
			vehicle = this.data.vehicleEntity?.name || "";
		} else if (this.data.vehicleEntity) {
			vehicle = this.data.vehicleEntity || "";
		}
		return vehicle;
	  } else if (this.column == "vehicleTranshipment") {
		let vehicleTranshipment = this.data.vehicleTranshipment || "";
		if (this.data.vehicleTranshipmentEntity?.name) {
			vehicleTranshipment = this.data.vehicleTranshipmentEntity?.name || "";
		} else if (this.data.vehicleTranshipmentEntity) {
			vehicleTranshipment = this.data.vehicleTranshipmentEntity || "";
		}
		return vehicleTranshipment;
	  } else if (this.column == "diRegistryDate") {
		let registryDate = this.data.diRegistryDate || "";
		if (this.data.duimp) {
			registryDate = this.data.duimpRegistryDate || "";
		}
		return registryDate && moment(registryDate).isValid() ? moment(registryDate).format("DD/MM/YY") : "";
	  } else if (this.column == "datesInspectionOfTheDIDate") {
		let inspectionDate = this.data.datesInspectionOfTheDIDate || "";
		if (this.data.duimp) {
			inspectionDate = this.data.datesInspectionOfTheDuimpDate || "";
		}
		return inspectionDate && moment(inspectionDate).isValid() ? moment(inspectionDate).format("DD/MM/YY") : "";
	  } else if (this.column == "diNumber") {
		if (this.data.duimp) {
			return this.data.duimpIdentification;
		} else {
			return this.data.diNumber;
		}
	  } else if (this.column == "diTypingDate") {
		let typingDate = this.data.diTypingDate || "";
		if (this.data.duimp) {
			typingDate = this.data.duimpTypingDate || "";
		}
		return typingDate && moment(typingDate).isValid() ? moment(typingDate).format("DD/MM/YY") : "";
      } else if (this.column == "diResourcefulnessDate") {
		let resourcefulnessDate = this.data.diResourcefulnessDate || "";
		if (this.data.duimp) {
			resourcefulnessDate = this.data.duimpResourcefulnessDate || "";
		}
		return resourcefulnessDate && moment(resourcefulnessDate).isValid() ? moment(resourcefulnessDate).format("DD/MM/YY") : "";

	  } else if (this.column == "customerExpectedReceiptDate") {
		let customerExpectedReceiptDate = this.data.customerExpectedReceiptDate || "";
		return customerExpectedReceiptDate && moment(customerExpectedReceiptDate).isValid() ? moment(customerExpectedReceiptDate).format("DD/MM/YY") : "";

      } else if (this.column == "stepInsurance") {
        if (
          (this.data.customer !== null &&
            this.data.customerInsuranceWithPrime) ||
          this.data.stepInsuranceValueResponsability === null ||
          this.data.stepInsuranceValueResponsability === "PRIME"
        ) {
          if (
            this.data.totalAmountInsurance !== null &&
            this.data.totalAmountInsurance > 0
          ) {
            return "OK";
          }
          return "N/I";
        }
        return "OK";
      } else if (
        this.column == "stepCashRequest" &&
        this.data.stepCashRequestSolved
      ) {
        return "OK";
      } else if (
        this.column == "billingCustomBrokerFinishDate" &&
        this.data.billingCustomBrokerFinishDateSolved
      ) {
        return "OK";
      } else if (
        this.column == "originalsDocumentsDate" &&
        this.data.originalsDocumentsDateSolved
      ) {
        return "OK";
      } else if (
        this.column == "originalsBillOfLadingDate" &&
        this.data.originalsBillOfLadingDateSolved
      ) {
        return "OK";
      } else if (
        this.column == "billingNFsDate" &&
        this.data.billingNFsDateSolved
      ) {
        return "OK";
      } else if (
        this.column == "billingBillCustomerDate" &&
        this.data.billingBillCustomerDateSolved
      ) {
        return "OK";
      } else if (
        this.column == "billingEmailDate" &&
        this.data.billingEmailDateSolved
      ) {
        return "OK";
      } else if (
        this.column == "billingCustomBrokerFinishDate" &&
        this.data.billingEmailDateSolved
      ) {
        return "OK";
      } else if (
        this.column == "datesInspectionMAPADate" &&
        this.data.datesInspectionMAPADateSolved
      ) {
        return "OK";
      } else if (
        this.column == "datesReleaseMAPADate" &&
        this.data.datesReleaseMAPADateSolved
      ) {
        return "OK";
      } else if (this.column == "datesDTCDTA") {
        if (this.data.datesDTCDTA) {
          return moment(this.data[this.column]) != "Invalid date"
            ? moment(this.data[this.column]).format("DD/MM/YY")
            : "";
        }
        if (this.data.datesIsThereDTCDTATransfer) {
          return "Sim";
        }
        return "Não";
      } else if (this.column == "step") {
        if (typeof this.data.step === "object") {
          return `<span class="tx-normal uppercase">${this.data.step.description}</span>`;
        }
        return `<span class="tx-normal uppercase">${this.data.step}</span>`;
      } else if (this.column === "customsEnclosureURFEntrance") {
        return this.data[this.column] && this.data[this.column].description
          ? this.data[this.column].description
          : "";
      } else if (this.column === "freightForwarder") {
        if (this.data.forwarder === null || this.data.forwarder === undefined) {
          if (this.data.freightForwarder) {
            return this.data.freightForwarder instanceof Object
              ? `<span class="tx-center tx-normal">${this.data?.freightForwarder?.name}</span>`
              : `<span class="tx-center tx-normal">${this.data?.freightForwarder}</span>`;
          }

          return '<span class="tx-center tx-normal"></span>';
        }

        return `<span class="tx-center tx-normal">${this.data.forwarder}</span>`;

        // return `<span class="tx-center tx-normal">${this.data.freightForwarder.name}</span>`;
      } else if (this.data[this.column] && this.dates.includes(this.column)) {
        if (this.data[this.column] === null || this.data[this.column] === "") {
          return contentDefault;
        }
        return moment(this.data[this.column]) != "Invalid date"
          ? moment(this.data[this.column]).format("DD/MM/YY")
          : "";
      } else if (this.data[this.column] && this.datetimes.includes(this.column)) {
        if (this.data[this.column] === null || this.data[this.column] === "") {
          return contentDefault;
        }
        return moment(this.data[this.column]) != "Invalid date"
          ? moment(this.data[this.column]).format("DD/MM/YY HH:mm:ss")
          : "";
      } else if (
        this.data.wayOfTransport === "MARITIMA" &&
        this.data.typeOfBoarding === "FCL" &&
        this.column === "freetime"
      ) {
        var deadline = null;

        if (
          this.data.datesArrivalDate !== null &&
          this.data.freetime !== null
        ) {
          deadline = moment(this.data.datesArrivalDate).add(
            parseInt(this.data.freetime) - 1,
            "day"
          );
        } else if (this.data.datesETA !== null && this.data.freetime !== null) {
          deadline = moment(this.data.datesETA).add(
            parseInt(this.data.freetime) - 1,
            "day"
          );
        }

        if (deadline != null) {
          if (this.expiredDeadline(this.data.containers, deadline)) {
            return `<span data-html="true" data-title='Deadline em ${deadline.format(
              "DD/MM/YY"
            )}'>D</span>`;
          }
          // Comentado pois atualmente a regra não faz sentido
          if (this.deadlineFinished(this.data.containers, deadline)) {
            return `<span data-html="true"  data-title='Deadline em ${deadline.format(
              "DD/MM/YY"
            )}'>OK</span>`;
          }
          return `<span data-html="true"  data-title='Freetime de ${
            this.data.freetime
          } dias'>${deadline.format("DD/MM/YY")}</span>`;
        }

        if (typeof this.data.freightForwarder === "object") {
          return `<span class="text-center tx-normal">${this.data?.freightForwarder?.name}`
            ? this.data?.freightForwarder?.name
            : `${this.data.freightForwarder.completeName}</span>`;
        }

        return this.data.forwarder
          ? `<span class="tx-center tx-normal">${this.data.forwarder}</span>`
          : "";
      } else if (this.column === "customer") {
        let content = "";
        if (typeof this.data.customer === "object") {
          content =
            `<span class="text-center tx-normal">${this.data.customer.name}`
              ? this.data.customer.name
              : `${this.data.customer.completeName}</span>`;
        }

        if (typeof this.data.customer === "string") {
          content = `<span class="text-center tx-normal">${this.data.customer}</span>`;
        }

        if (this.data.hasWithoutOperationalTeamAlert) {
          content +=
            ' <span class="text-medium text-danger">Sem time operacional</span>';
        }

        return content;
      } else if (this.column === "customsEnclosure") {
        if (this.data.customsEnclosure === null) {
          return '<span class="tx-center tx-normal"></span>';
        }

        if (typeof this.data.customsEnclosure === "object") {
          if (
            this.data.customsEnclosure.alias &&
            this.data.customsEnclosure.alias !== null &&
            this.data.customsEnclosure.alias !== ""
          ) {
            return `<span class="text-center tx-normal">${this.data.customsEnclosure.alias}</span>`;
          }
          return `<span class="text-center tx-normal">${this.data.customsEnclosure.name}`
            ? this.data.customsEnclosure.name
            : `${this.data.customsEnclosure.completeName}</span>`;
        }

        return `<span class="tx-center tx-normal">${this.data.customsEnclosure}</span>`;
      } else if (this.column === "exporter") {
        if (this.data.exporter === null) {
          return '<span class="tx-center tx-normal"></span>';
        }

        if (typeof this.data.exporter === "object") {
          return `<span class="text-center tx-normal">${this.data.exporter.name}`
            ? this.data.exporter.name
            : `${this.data.exporter.completeName}</span>`;
        }

        return `<span class="text-center tx-normal">${this.data.exporter}</span>`;
      } else if (this.column === "manufacturer") {
        if (this.data.manufacturer === null) {
          return '<span class="tx-center tx-normal"></span>';
        }

        if (typeof this.data.manufacturer === "object") {
          return `<span class="text-center tx-normal">${this.data.manufacturer.name}`
            ? this.data.manufacturer.name
            : `${this.data.manufacturer.completeName}</span>`;
        }

        return `<span class="tx-center tx-normal">${this.data.manufacturer}</span>`;
      } else if (this.column === "generalWarehouse") {
        if (this.data.generalWarehouse === null) {
          return '<span class="tx-center tx-normal"></span>';
        }

        if (typeof this.data.generalWarehouse === "object") {
          return `<span class="text-center tx-normal">${this.data.generalWarehouse.name}`
            ? this.data.generalWarehouse.name
            : `${this.data.generalWarehouse.completeName}</span>`;
        }

        return `<span class="tx-center tx-normal">${this.data.generalWarehouse}</span>`;
      } else if (this.column === "conveyor") {
        if (this.data.conveyor === null) {
          return '<span class="tx-center tx-normal"></span>';
        }

        if (typeof this.data.conveyor === "object") {
          if (
            this.data.conveyor.alias &&
            this.data.conveyor.alias !== null &&
            this.data.conveyor.alias !== ""
          ) {
            return `<span class="text-center tx-normal">${this.data.conveyor.alias}</span>`;
          }
          return `<span class="text-center tx-normal">${this.data.conveyor.name}`
            ? this.data.conveyor.name
            : `${this.data.conveyor.completeName}</span>`;
        }

        return `<span class="tx-center tx-normal">${this.data.conveyor}</span>`;
      } else if (this.column === "expectedDeliveryTime") {
        if (this.data.expectedDeliveryTime) {
          const expectedDeliveryTime = moment(this.data.expectedDeliveryTime);
          const now = moment();
          let expectedDeliveryTimeElement = `${expectedDeliveryTime.format(
            "DD/MM/YY"
          )} - ${this.data.expectedDeliveryTimeDays}`;

          if (
            this.data.expectedDeliveryTimeExpiresToday != null && this.data.expectedDeliveryTimeExpiresToday === true
          ) {
            expectedDeliveryTimeElement = `<div style="text-align: center; color: #cf7105;">${expectedDeliveryTime.format(
              "DD/MM/YY"
            )} <br/> Vence hoje!</div>`;
          } else if (this.data.expectedDeliveryTimeExpired != null && this.data.expectedDeliveryTimeExpired === true) {
            expectedDeliveryTimeElement = `<div style="text-align: center;" class="text-danger">${expectedDeliveryTime.format(
              "DD/MM/YY"
            )} <br/> Venceu a <span style="font-size: 13px;"><strong>${
              this.data.expectedDeliveryTimeDays
            }</strong></span> ${
              this.data.expectedDeliveryTimeDays > 1 ? "dias" : "dia"
            }!</div>`;
          } else if (this.data.expectedDeliveryTimeWillExpire != null && this.data.expectedDeliveryTimeWillExpire === true) {
            expectedDeliveryTimeElement = `<div style="text-align: center;">${expectedDeliveryTime.format(
              "DD/MM/YY"
            )} <br/> Vence em <span style="font-size: 13px;"><strong>${Math.abs(
              this.data.expectedDeliveryTimeDays
            )}</strong></span> dias!</div>`;
          } else if (this.data.expectedDeliveryTimeWillExpireTomorrow != null && this.data.expectedDeliveryTimeWillExpireTomorrow === true) {
            expectedDeliveryTimeElement = `<div style="text-align: center;">${expectedDeliveryTime.format(
              "DD/MM/YY"
            )} <br/> Vence amanhã</div>`;
          }

          return expectedDeliveryTimeElement;
        }
        return '<div class="text-center">-</div>';
      } else if (this.column === "billingTerm") {
        return `<div class="text-center">${
          this.data.billingTerm ? `${this.data.billingTerm} dias` : "-"
        }</div>`;
      } else if (this.column === "customBroker") {
        if (this.data.customBroker === null) {
          return '<span class="tx-center tx-normal"></span>';
        }

        if (typeof this.data.customBroker === "object") {
          return `<span class="text-center tx-normal">${this.data.customBroker.name}`
            ? this.data.customBroker.name
            : `${this.data.customBroker.completeName}</span>`;
        }

        return `<span class="tx-center tx-normal">${this.data.customBroker}</span>`;
      } else if (this.column === "shipowner") {
        if (this.data.shipowner === null) {
          return '<span class="tx-center tx-normal"></span>';
        }

        if (typeof this.data.shipowner === "object") {
          return `<span class="text-center tx-normal">${this.data.shipowner.name}`
            ? this.data.shipowner.name
            : `${this.data.shipowner.completeName}</span>`;
        }

        return `<span class="tx-center tx-normal">${this.data.shipowner}</span>`;
	
		} else if (this.column == "destinationPort") {
			if (this.data.destinationPort === null) {
			return '<span class="tx-center tx-normal"></span>';
			}

			if (typeof this.data.destinationPort === "object" && this.data.destinationPort?.alias) {
			return `<span class="text-center tx-normal">${this.data.destinationPort.alias}</span>`;
			}

			return `<span class="tx-center tx-normal">${this.data.destinationPort}</span>`;
      } else if (this.objects.includes(this.column)) {
        if (this.column === "account") {
          const content =
            this.data[this.column] && this.data[this.column].federalUnity
              ? this.data[this.column].federalUnity
              : "";
          return `<span class="tx-center tx-normal uppercase">${content}</span>`;
        }
        return this.data[this.column] && this.data[this.column].name
          ? this.data[this.column].name
          : "";
      } else if (this.booleans.includes(this.column)) {
        return this.data[this.column] !== null
          ? this.data[this.column]
            ? "Sim"
            : "Não"
          : "N/I";
      } else if (this.data[this.column] && this.dates.includes(this.column)) {
        if (this.data[this.column] === null || this.data[this.column] === "") {
          return contentDefault;
        }
        return moment(this.data[this.column]) != "Invalid date"
          ? moment(this.data[this.column]).format("DD/MM/YY")
          : "";
      } else if (
        this.data.wayOfTransport === "MARITIMA" &&
        this.data.typeOfBoarding === "FCL" &&
        this.column === "freetime"
      ) {
        var deadline = null;

        if (
          this.data.datesArrivalDate !== null &&
          this.data.freetime !== null
        ) {
          deadline = moment(this.data.datesArrivalDate).add(
            parseInt(this.data.freetime) - 1,
            "day"
          );
        } else if (this.data.datesETA !== null && this.data.freetime !== null) {
          deadline = moment(this.data.datesETA).add(
            parseInt(this.data.freetime) - 1,
            "day"
          );
        }

        if (deadline != null) {
          if (this.expiredDeadline(this.data.containers, deadline)) {
            return `<span data-html="true" data-title='Deadline em ${deadline.format(
              "DD/MM/YY"
            )}'>D</span>`;
          }
          if (this.deadlineFinished(this.data.containers, deadline)) {
            return `<span data-html="true"  data-title='Deadline em ${deadline.format(
              "DD/MM/YY"
            )}'>OK</span>`;
          }
          return `<span data-html="true"  data-title='Freetime de ${
            this.data.freetime
          } dias'>${deadline.format("DD/MM/YY")}</span>`;
        }
      } else if (
        this.data.typeOfBoarding !== "FCL" &&
        this.column === "freetime"
      ) {
        return '<span class="tx-center tx-normal uppercase">N/A</span>';
      } else if (this.column == "customer.isMinimalComissionPercentual") {
        if (this.data.isMinimalComissionPercentual == true) {
          return "Sim";
        }
        if (this.data.isMinimalComissionPercentual == false) {
          return "Não";
        }
      } else if (this.column == "duimp") {
        if (this.data.duimp === true || this.data.duimp === "true") {
          return '<div class="tx-center"><i class="tx-16-force fa fa-check tx-success" style="color: #00A068;!important;"></i></div>';
        } else {
          return '<div class="tx-center"><i class="tx-18-force fa fa-times tx-danger" style="color: #dc3545 !important;"></i></div>';
        }

      } else if (this.column === "ceMercanteChecked") {
        return this.ceMercanteCheckedBadgeHtml(
          this.resolveCeMercanteCheckedSituation(this.data.ceMercanteChecked)
        );

	 } else if (this.column == "processUseOfGoods") {
		return this.data.processUseOfGoods ? this.data.processUseOfGoods.map((processUseOfGoods) => processUseOfGoods.description).join(', ') : '-';
	 } else if (this.column == "urgent") {
        if (this.data.urgent === true || this.data.urgent === "true") {
          return '<div class="tx-center"><i class="tx-16-force fa fa-check tx-success" style="color: #00A068;!important;"></i></div>';
        } else {
          return '<div class="tx-center"><i class="tx-18-force fa fa-times tx-danger" style="color: #dc3545 !important;"></i></div>';
        }
	 } else if (this.column == "productCatalog") {
        return this.yesOrCheckDate(this.data.productCatalog, this.data.productCatalogDate);
	 } else if (this.column == "drawback") {
        if (this.data.drawback === true || this.data.drawback === "true") {
          return 'Sim';
        } else {
          return 'Não';
        }
	 } else if (this.column == "priorityTypes") {
		if (this.data.priorityTypes.length > 0) {
			let diDiamond = false;
			let factory = false;
			let precisionManufacturing = false;

			diDiamond = this.data.priorityTypes.find((priorityType) => priorityType.code === "HIGH_VALUE");
			factory = this.data.priorityTypes.find((priorityType) => priorityType.code === "PROJECT");
			precisionManufacturing = this.data.priorityTypes.find((priorityType) => priorityType.code === "MACHINERY");

			let div = '<div class="tx-center">';

			if (diDiamond) {
				div += '<span class="pr-2" data-html="true" data-title="Alto Valor"><svg  xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 -960 960 960" width="25px" fill="#5b93d3"><path d="M480-144 96-576l96-240h576l96 240-384 432Zm-86-468h172l-66-132h-40l-66 132Zm50 319v-247H224l220 247Zm72 0 220-247H516v247Zm130-319h126l-52-132H580l66 132Zm-458 0h126l66-132H241l-53 132Z"/></svg></span>';
			}
			if (factory) {
				div += '<span class="pr-2" data-html="true" data-title="Projeto"><svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 -960 960 960" width="25px" fill="#868BA1"><path d="M96-96v-456l264-120v84l192-84v120h312v456H96Zm72-72h624v-312H480v-82l-192 84v-82l-120 55v337Zm276-72h72v-168h-72v168Zm-156 0h72v-168h-72v168Zm312 0h72v-168h-72v168Zm264-312H672l48-312h96l48 312ZM168-168h624-624Z"/></svg></span>';
			}
			if (precisionManufacturing) {
				div += '<span class="pr-2" data-html="true" data-title="Máquinário"><svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 -960 960 960" width="25px" fill="#F49918"><path d="M192-144v-120h90l-69-275q-32-15-50.5-44.5T144-648q0-51 35-85.5t86-34.5q39 0 70.5 23t42.5 61h78v-48q0-15 10.5-25.5T492-768q15 0 25.5 10.5T528-732v7l96-82q8-7 18-8t20 3l133 60q14 6 19.5 19.5T813-705q-6 13-20 18t-28 0l-112-50-105 89 105 90 112-50q14-6 27.5-1t20.5 19q6 13 .5 26T795-543l-133 60q-9 5-19.5 3.5T624-488l-96-82v6q0 15-10.5 25.5T492-528q-15 0-25.5-10.5T456-564v-48h-78q-4 14-11.5 25.5T349-564l172 300h151v120H192Zm72-450q23 0 38.5-15.5T318-648q0-22-15.5-37.5T264-701q-23 0-38.5 15.5T210-648q0 23 15.5 38.5T264-594Zm92 330h82L292-519h-.5.5l64 255Zm82 0Z"/></svg></span>';
			}
			div += '</div>';

			return div;
		
		} else {
			return '<div class="tx-center"><i class="tx-18-force fa fa-times tx-danger" style="color: #dc3545 !important;"></i></div>';
		}
	} else if (this.column == "priority") {
        if (this.data.priority === true || this.data.priority === "true") {
          return '<div class="tx-center"><i class="tx-16-force fa fa-check tx-success" style="color: #00A068;!important;"></i></div>';
        } else {
          return '<div class="tx-center"><i class="tx-18-force fa fa-times tx-danger" style="color: #dc3545 !important;"></i></div>';
        }
	 } else if (this.column == "quantityContainer") {
		return this.data?.quantityContainer ?? this.data?.containers?.length ?? 0;
	 } else if (this.column == "stepInsuranceValueResponsability") {
		if (this.data.stepInsuranceValueResponsability === 'PRIME') {
			return 'A Prime';
		} else if (this.data.stepInsuranceValueResponsability === 'CLIENTE'){
			return 'O Cliente';
		} else if (this.data.stepInsuranceValueResponsability === 'NAO_SE_APLICA'){
			return 'Não se Aplica';
		} else {
			return 'N/I';
		}
	 } else if (this.column == "administrativeTreatmentDone") {
		return this.yesOrCheckDate(this.data.administrativeTreatmentDone, this.data.administrativeTreatmentDoneDate);
	  } else if (this.column == "importLicense") {
        if (this.data.importLicense === true || this.data.importLicense === "true") {
          return '<div class="tx-center"><i class="tx-16-force fa fa-check tx-success" style="color: #00A068;!important;"></i></div>';
        } else {
          return '<div class="tx-center"><i class="tx-18-force fa fa-times tx-danger" style="color: #dc3545 !important;"></i></div>';
        }
      } else if (this.column == "cashRequestDone") {
        if (this.data.cashRequestDone === true || this.data.cashRequestDone === "true") {
          return `<div class="tx-center"><span class="tx-center tx-normal uppercase" style="text-align: center; background: #00A068; color: white; padding: 4px; border: 1px; border-radius: 5px;">PAGO</span></div>`;
        } else {
          return `<div class="tx-center"><span class="tx-center tx-normal uppercase" style="text-align: center;background: #dc3545; color: white; padding: 4px;  border: 1px; border-radius: 5px;">PENDENTE</span></div>`;
        }
      } else if (this.money.includes(this.column)) {
        if (this.data[this.column] === null || this.data[this.column] === undefined || this.data[this.column] === "") {
          return '-';
        }
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(this.data[this.column]);
      }

      return this.data[this.column];
    },
    specialClass() {
      let especialClassContent = " valign-middle pd-x-5 pd-y-10 tx-gray-700";

      if (this.column === "identification") {
        especialClassContent += " tx-center ";

        if (this.data.urgent === true)
          especialClassContent += " tx-white bg-danger";
      } else if (this.column === "status") {
        especialClassContent += " tx-center ";
      } else if (this.column === "operationStatus") {
        if (this.data.urgent === true)
          especialClassContent += " tx-white bg-danger";
        else especialClassContent += " tx-center ";
      } else if (this.column === "step") {
        especialClassContent += " tx-center ";
      } else if (this.column === "duimpChannel" 
	  	|| this.column === "duimpVersion" 
	  	|| this.column === "priorityTypes" 
		|| this.column === "priority" 
		|| this.column === "urgent" 
		|| this.column === "duimpAccessKey" 
		|| this.column === "ceMercanteChecked" 
		|| this.column === "team" 
		|| this.column === "customsTeam" 
		|| this.column === "productCatalog" 
		|| this.column === "administrativeTreatmentDone"
		|| this.column === "drawback"
		|| this.column === "consentingAgency") {
        especialClassContent += " tx-center ";
	  } else if (this.column === "quantityContainer") {
		especialClassContent += " tx-center ";
      } else if (
        this.column === "stepCashRequest" &&
        this.data.datesETD !== null &&
        (this.data.stepCashRequest === null || !this.data.stepCashRequest) &&
        (this.data.stepCashRequestSolved === null ||
          this.data.stepCashRequestSolved !== true) &&
        this.data.customer !== null &&
        this.data.customer.numberOfDaysForCashNotification !== null
      ) {
        // Numerário do Cliente
        var date = moment(this.data.datesETD);
        var diff = moment.duration(
          date.diff(moment(moment().startOf("day")), "days", true)
        );

        if (diff <= this.data.customer.numberOfDaysForCashNotification) {
          especialClassContent += " bg-green tx-white tx-bold tx-center";
        }
      } else if (
        this.column === "billingCustomBrokerFinishDate" &&
        this.data.datesGoodsLoadingDate !== null &&
        (this.data.billingCustomBrokerFinishDate === null ||
          !this.data.billingCustomBrokerFinishDate) &&
        (this.data.billingCustomBrokerFinishDateSolved === null ||
          this.data.billingCustomBrokerFinishDateSolved !== true)
      ) {
        // Encerramento Despachante

        var date = moment(this.data.datesGoodsLoadingDate);
        var diff = moment.duration(
          date.diff(moment(moment().startOf("day")), "days", true)
        );

        if (diff >= 3)
          especialClassContent += " bg-orange tx-white tx-bold tx-center";
      } else if (this.column === "datesETA" && this.data.datesETA !== null) {
        // Alertas do ETA
        var date = moment(this.data.datesETA);
        var diff = moment.duration(
          date.diff(moment(moment().startOf("day")), "days", true)
        );

        if (diff > 7 && diff <= 14)
          especialClassContent += " bg-yellow tx-white tx-bold tx-center ";
        // 7 e 14 dias
        else if (diff <= 7 && diff > 0)
          especialClassContent += " bg-red tx-white tx-bold tx-center ";
        // 7 dias
        else if (diff == 0)
          especialClassContent += " bg-purple tx-white tx-bold tx-center "; // Hoje
      } else if (
        this.column === "diNumber" &&
		this.data.duimp !== true &&
        this.data.datesArrivalDate !== null &&
        (this.data.diNumber === null || !this.data.diNumber) &&
        (this.data.diRegistryDate === null || this.data.diRegistryDate !== true)
      ) {
        // Alertas da DI
        var date = moment(this.data.datesArrivalDate);
        var diff = moment.duration(
          date.diff(moment(moment().startOf("day")), "days", true)
        );

        if (diff <= -2)
          especialClassContent += " bg-orange tx-white tx-bold tx-center ";
      } else if (
        this.column === "datesGoodsLoadingDate" &&
        (this.data.diResourcefulnessDate !== null ||
          this.data.diResourcefulnessDate === true) &&
        (this.data.datesGoodsLoadingDate === null ||
          !this.data.datesGoodsLoadingDate)
      ) {
        // Alerta - Carregamento
        var date = moment(this.data.diResourcefulnessDate);
        var diff = moment.duration(
          date.diff(moment(moment().startOf("day")), "days", true)
        );

        if (diff <= -2)
          especialClassContent += " bg-orange tx-white tx-bold tx-center ";
      } else if (
        this.column === "originalsDocumentsDate" &&
        this.data.datesETA !== null &&
        (this.data.originalsDocumentsDate === null ||
          !this.data.originalsDocumentsDate) &&
        (this.data.originalsDocumentsDateSolved === null ||
          !this.data.originalsDocumentsDateSolved)
      ) {
        // Alerta - Documentos
        var date = moment(this.data.datesETA);
        var diff = moment.duration(
          date.diff(moment(moment().startOf("day")), "days", true)
        );

        if (diff <= 14) {
          especialClassContent += " bg-orange tx-white tx-bold tx-center ";
        }
      } else if (
        this.column === "datesCustomerDeliverDate" &&
        this.data.datesGoodsLoadingDate !== null &&
        (this.data.datesCustomerDeliverDate === null ||
          !this.data.datesCustomerDeliverDate)
      ) {
        // Alerta - Entrega
        var date = moment(this.data.datesGoodsLoadingDate);
        var diff = moment.duration(
          date.diff(moment(moment().startOf("day")), "days", true)
        );

        if (diff < 1)
          especialClassContent += " bg-orange tx-white tx-bold tx-center ";
      } else if (
        (this.column === "datesIsThereDTCDTATransfer" ||
          this.column === "datesDTCDTA") &&
        this.data.datesIsThereDTCDTATransfer !== null &&
        this.data.datesIsThereDTCDTATransfer == true &&
        (this.data.datesDTCDTA === null || !this.data.datesDTCDTA)
      ) {
        // Alerta - DTC / DTA
        especialClassContent += " bg-orange tx-white tx-bold tx-center ";
      }

      if (this.objects.includes(this.column)) {
        especialClassContent += " tx-left ";
      } else if (this.dates.includes(this.column) || this.datetimes.includes(this.column)) {
        especialClassContent += " tx-center ";
      } else if (this.booleans.includes(this.column)) {
        especialClassContent += " tx-center ";
	  } else if (this.column === "diRegistryDate" || this.column === "diTypingDate" || this.column === "diResourcefulnessDate") {
		especialClassContent += " tx-center ";
      } else if (
        this.data.wayOfTransport === "MARITIMA" &&
        this.data.typeOfBoarding === "FCL" &&
        this.column === "freetime" &&
        this.data.freetime !== null
      ) {
        var date = null;

        if (
          this.data.datesETA !== null &&
          this.data.datesArrivalDate === null
        ) {
          date = moment(this.data.datesETA).add(
            parseInt(this.data.freetime) - 1,
            "day"
          );
        } else if (this.data.datesArrivalDate !== null) {
          date = moment(this.data.datesArrivalDate).add(
            parseInt(this.data.freetime) - 1,
            "day"
          );
        }

        if (date != null) {
          var diff = moment.duration(
            date.diff(moment(moment().startOf("day")), "days", true)
          );
          if (diff >= 0 && diff <= 5) {
            if (this.deadlineFinished(this.data.containers, date)) {
              especialClassContent += " tx-bold ";
            } else {
              especialClassContent += " bg-yellow tx-white tx-bold ";
            }
          } else if (diff < 0) {
            if (this.expiredDeadline(this.data.containers, date)) {
              especialClassContent += " bg-black x-bold";
            } else if (this.deadlineFinished(this.data.containers, date)) {
              especialClassContent += " tx-bold ";
            } else {
              especialClassContent += " bg-red tx-white tx-bold ";
            }
          }
        }

        especialClassContent += " tx-center ";
      } else if (this.column === "customer.isMinimalComissionPercentual") {
        especialClassContent += " tx-center ";
      } else if (this.column === "diChannel") {
        especialClassContent += " tx-center ";
      }

      return especialClassContent;
    },
    specialStyle() {
      if (this.column == "step") {
        if (typeof this.data.step === "object") {
          return {
            backgroundColor: this.data.step.color,
            color: this.data.step.color === "#000000" ? "#000000" : "#FFFFFF",
          };
        }

        return {
          backgroundColor: this.data.stepColor,
          color: this.data.stepTextColor === "#000000" ? "#000000" : "#FFFFFF",
        };
      }
	  else if (this.column === "diNumber"){
		return {
			minWidth: "125px",
		};
      }
      return undefined;
    },
  },
  methods: {
    resolveCeMercanteCheckedSituation(v) {
      if (v === true || v === "true" || v === 1) {
        return "conferido";
      }
      if (v === false || v === "false" || v === 0) {
        return "divergente";
      }
      if (typeof v === "string") {
        var t = v.trim().toLowerCase();
        if (t === "conferido") {
          return "conferido";
        }
        if (t === "divergente") {
          return "divergente";
        }
        if (t === "pendente") {
          return "pendente";
        }
      }
      return "pendente";
    },
    ceMercanteCheckedBadgeHtml(situation) {
      var cfg =
        situation === "conferido"
          ? { bg: "#00A068", label: "CONFERIDO" }
          : situation === "divergente"
            ? { bg: "#dc3545", label: "DIVERGENTE" }
            : { bg: "#868ba1", label: "PENDENTE" };
      return `<div class="tx-center"><span class="tx-center tx-normal uppercase" style="text-align: center;background: ${cfg.bg}; color: white; padding: 4px; border: 1px; border-radius: 5px;">${cfg.label}</span></div>`;
    },
    yesOrCheckDate(checked, date) {
      if (date && moment(date).isValid()) {
        return moment(date).format("DD/MM/YY");
      }
      if (checked === true || checked === "true") {
        return "Sim";
      }
      return "Não";
    },
    getTypeOfProcessReferenceByProcess(process) {
      return ProcessService.getTypeOfProcessReference(process);
    },
    expiredDeadline(containers, deadline) {
      if (containers.length > 0) {
        const filtered = containers.filter((c) => {
          if (c.devolution !== null && deadline !== null) {
            return (
              moment(deadline).format("DD/MM/YY") !==
                moment(c.devolution).format("DD/MM/YY") &&
              moment(deadline).isBefore(moment(c.devolution), "days")
            );
          }
          return false;
        });

        return filtered.length > 0;
      }
      return false;
    },
    deadlineFinished(containers, deadline) {
      if (containers.length > 0 && deadline !== null) {
        const filtered = containers.filter((c) => {
          if (c.devolution !== null) {
            return moment(c.devolution).isSameOrBefore(
              moment(deadline),
              "days"
            );
          }
          return false;
        });

        return filtered.length > 0;
      }
      return false;
    },
    async action() {
      
      if (this.data !== null && this.data.identification !== null && (this.column == "id" || this.column == "identification")) {
        
        try {
          
          this.$store.commit("setLoading", { show: true, label: `Processo de Importação`, description: "Carregando informações." });

          const findProcessById = await this.$store.dispatch("ProcessStore/findProcessById", this.data.id);
          
          if(findProcessById) {
            
            if(!findProcessById.success) {
              Swal.fire(`Visualização de Processo`, `Não foi possível abrir o processo ${this.data.identification} por causa do seguinte erro: ${response.error}`, `error`);
            }

          } else {

            if (!this.opennedBy) {
              this.socket.send(
                JSON.stringify({
                  action: config.env.WEBSOCKET.actions.OPEN_PROC,
                  data: {
                    [this.data.id]: this.credentials.data.person.name,
                  },
                })
              );
            }

          }
          
        } catch (error) {
          Swal.fire(`Visualização de Processo`, `Não foi possível abrir o processo ${this.data.identification} por causa do seguinte erro: ${error}`, `error`);
        }
      }

    },
    broadcastProcessUpdate(processId, fields) {
      this.socket.send(
        JSON.stringify({
          action: config.env.WEBSOCKET.actions.UPDATE_PROC,
          data: {
            [processId]: fields,
          },
        })
      );
    },
    pullTrigger(processId, fieldName) {
      return Axios.post(
        config.env.API_DEFAULT.host + "/newImportProcess/" + processId + "/pull-trigger/" + fieldName
      ).catch((errorResponse) => {
        if (errorResponse.response !== undefined) {
          Vue.toasted.error(errorResponse.response.data.message, { position: "top-right", duration: 6000 });
        } else {
          console.error("Erro -> Pull Trigger", errorResponse);
        }
        return null;
      });
    },
    async checkProcessEvents(processId, fieldName, identification) {
      try {
        const responseCheckEventTrue = await Axios.get(
          config.env.API_DEFAULT.host + "/process/import/checkEvent/" + processId + "/" + fieldName + "/check/true"
        );
        if (!responseCheckEventTrue) {
          return;
        }

        let msg = "";
        let message = "";
        let messageItemText = "";

        if (
          responseCheckEventTrue.data.listOfMessages !== undefined &&
          responseCheckEventTrue.data.listOfMessages !== null &&
          responseCheckEventTrue.data.listOfMessages.length > 0
        ) {
          message += "<ul class='list-group list-group-striped tx-14 tx-left'>";

          responseCheckEventTrue.data.listOfMessages.forEach((item) => {
            message +=
              "<li class='list-group-item tx-left'>" +
              "   <p class='mg-b-0 tx-left'>" +
              "       <i class='fa fa-check tx-success mg-r-8'></i> " +
              "       <span class='tx-inverse tx-normal'>" +
              item +
              "       </span>" +
              "   </p>" +
              "</li>";

            messageItemText += item + "\n";
          });

          message += "</ul>";

          msg =
            "<p class='mg-b-5 tx-18'>Os eventos abaixo foram encontrados, você deseja dispará-los?</p>" +
            message;
          msg = "<div class='tx-left'>" + msg + "</div>";
        } else {
          msg = responseCheckEventTrue.data.message;
        }

        if (responseCheckEventTrue.data.code === "SUCCESS") {
          Swal.fire("Eventos do Processo " + identification, msg, "success");
          const result = await Swal.fire({
            title: "Eventos do Processo " + identification,
            html: msg,
            showCancelButton: true,
            type: "warning",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Não enviar",
            confirmButtonText: "Enviar",
          });

          if (!result.value) {
            return;
          }

          this.$store.commit("setLoading", {
            show: true,
            label: "Enviando os eventos abaixo",
            description: messageItemText,
          });

          Axios.get(
            config.env.API_DEFAULT.host + "/process/import/checkEvent/" + processId + "/" + fieldName + "/check/false"
          ).then((response) => {
            this.$store.commit("setLoading", { show: false });
            if (response.data.data[0] !== undefined && response.data.data[0].code === "SUCCESS") {
              if (
                response.data.data[0].actions !== undefined &&
                response.data.data[0].actions !== null &&
                response.data.data[0].actions.CHANGE_STEP !== undefined &&
                response.data.data[0].actions.CHANGE_STEP !== null
              ) {
                const step = response.data.data[0].actions.CHANGE_STEP;
                const process = this.processes.find((item) => item.id === processId);
                if (process) {
                  this.$set(process, "step", step);
                }
                if (this.data && this.data.id === processId) {
                  this.$set(this.data, "step", step);
                }

                Axios.patch(config.env.API_DEFAULT.host + "/importProcesses/" + processId, {
                  step: config.env.API_DEFAULT.host + "/processSteps/" + step.id,
                }).then(() => {
                  this.broadcastProcessUpdate(processId, { step: step });
                });

                Swal.fire({
                  type: "success",
                  title: "Eventos do Processo " + identification,
                  html: "O Follow UP foi enviado com sucesso e a etapa do processo foi alterada para <strong>" + step.description + "</strong>.",
                  showConfirmButton: true,
                  timer: 5000,
                });
              } else {
                Swal.fire({
                  type: "success",
                  title: "Eventos do Processo " + identification,
                  html: response.data.data[0].message,
                  showConfirmButton: true,
                  timer: 5000,
                });
              }
              EventBus.$emit("Operational.imp.Form.Docs.load");
              EventBus.$emit("Operational.imp.Form.Sidebar.Timeline.load");
            } else {
              let warningMessage = ` <p>Processamento do evento:</p> <p>${response.data.data[0].message}</p>`;
              if (response.data.data[0].code === "ERROR" && response.data.data[0].data) {
                warningMessage += `<ul class="list-group">`;
                for (let i = 0; i < response.data.data[0].data.length; i++) {
                  warningMessage += `<li class="list-group-item">${labels[0][response.data.data[0].data[i]].label}</li>`;
                }
                warningMessage += `<ul>`;
              }
              Swal.fire("Eventos do Processo", warningMessage, "warning");
            }
          }).catch((error) => {
            console.error(error);
            this.$store.commit("setLoading", { show: false });
            Swal.fire(
              "Eventos do Processo",
              "Houve algum problema ao tentar processar o evento: \n <br />" + error.response.data.message,
              "error"
            );
          });
        } else if (responseCheckEventTrue.data.code === "ERROR") {
          Swal.fire(
            "Eventos do Processo " + identification,
            msg,
            "error"
          );
        }
      } catch (error) {
        console.error(error);
        const errorMessage = error.response && error.response.data ? error.response.data.message : error;
        Swal.fire(
          "Eventos do Processo",
          "Houve algum problema ao tentar processar o evento: \n <br />" + errorMessage,
          "error"
        );
      }
    },
    showFieldUpdated(oldValue, newValue) {
      let previous = oldValue;
      let current = newValue;

      if (this.fieldInfo.type === "date") {
        previous = this.$moment(oldValue).format("DD/MM/Y");
        current = this.$moment(newValue).format("DD/MM/Y");
      } else if (this.fieldInfo.type === "yes_or_no") {
        previous = oldValue === "true" || oldValue === true ? "Sim" : "Não";
        current = newValue === "true" || newValue === true ? "Sim" : "Não";
      }

      Swal.fire(
        `Atualização do Processo Nº ${this.data.identification}`,
        `${this.fieldInfo.label} foi atualizado de <strong>${previous}</strong> para <strong>${current}</strong>.`,
        "success"
      );
    },
    async edit() {
      
      if (this.opennedBy !== undefined && this.opennedBy !== null) {
        Swal.fire(
          "Processo Bloqueado!",
          `No momento este processo está sendo editado por <strong>${this.opennedBy}</strong>, aguarde este usuário finalizar para que você possar editar.`,
          "error"
        );
      } else if (this.fieldInfo.editableInDesk) {
        let html = "";
        html = `<label class="tx-left">Atualizando  o campo ${this.fieldInfo.label}:</label>`;

        let fieldToUpdate = this.column;
        if (this.column === "datesInspectionOfTheDIDate" && this.data.duimp) {
          fieldToUpdate = "datesInspectionOfTheDuimpDate";
        }

        let data = this.data[fieldToUpdate] || "";

        if (this.fieldInfo.type === "date") {
          // data = this.$moment(data).format("Y-MM-DD");
          html += `<input id="swal-input1" class="swal2-input" value="${data ? data.split('T')[0] : ''}" type="date">`;

		} else if (this.fieldInfo.type === "datetime") {
			html += `<input id="swal-input1" class="swal2-input" value="${data ? data.split('.')[0] : ''}" type="datetime-local" step="1">`;
        } else if (this.fieldInfo.type === "checkbox_solved") {
          html += `<input id="swal-input1" class="swal2-input" value="${data}">`;
        } else if (this.fieldInfo.type === "yes_or_no") {
          html += `<select id="swal-input1" class="swal2-input">
                      <option value="true" ${data === 'true' || data === true ? 'selected' : ''}>Sim</option>
                      <option value="false" ${data === 'false' || data === false ? 'selected' : ''}>Não</option>
                    </select>`;
        } else {
          html += `<input id="swal-input1" class="swal2-input" value="${data}">`;
        }

        const { value: formValues } = await Swal.fire({
          title: `Atualização do Processo Nº ${this.data.identification}`,
          html,
          // + '<input id="swal-input2" class="swal2-input">',
          focusConfirm: false,
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Salvar",
          preConfirm: () => document.getElementById("swal-input1").value,
        });

        if (formValues) {
          let newValue = formValues;
          const process = this.processes.find(
            (process) => process.id === this.data.id
          );
          let oldValue = this.data[fieldToUpdate];

          if (this.fieldInfo.type === "date") {
            newValue = `${newValue}T03:00:00`;
          }
		  
          if (process !== null) {
            process[fieldToUpdate] = newValue;

            Axios.patch(
              `${config.env.API_DEFAULT.host}/importProcesses/${process.id}`,
              {
                [fieldToUpdate]: newValue,
              }
            )
              .then((response) => {
                if (response.status === 200) {
                  this.broadcastProcessUpdate(process.id, {
                    [fieldToUpdate]: newValue,
                  });

                  if (this.fieldInfo.type === "date") {
                    this.pullTrigger(process.id, fieldToUpdate).then((response2) => {
                      if (!response2) {
                        return;
                      }
                      if (response2.data) {
                        Vue.toasted.success(response2.data.message, { position: "top-right", duration: 6000 });
                      }
                      this.checkProcessEvents(process.id, fieldToUpdate, this.data.identification);
                    });
                  } else if (this.fieldInfo.type === "yes_or_no") {
                    if (fieldToUpdate === "productCatalog" || fieldToUpdate === "administrativeTreatmentDone") {
                      const dateField = fieldToUpdate === "productCatalog" ? "productCatalogDate" : "administrativeTreatmentDoneDate";
                      this.pullTrigger(process.id, fieldToUpdate).then((response2) => {
                        if (!response2) {
                          return;
                        }
                        const updated = response2.data && response2.data.data;
                        if (updated) {
                          const dateValue = updated[dateField] || null;
                          this.$set(process, dateField, dateValue);
                          if (this.data) {
                            this.$set(this.data, dateField, dateValue);
                          }
                          this.broadcastProcessUpdate(process.id, {
                            [dateField]: dateValue,
                          });
                        }
                        this.checkProcessEvents(process.id, fieldToUpdate, this.data.identification);
                      });
                    }
                  } else if (fieldToUpdate === "status" || fieldToUpdate === "operationStatus") {
                    this.pullTrigger(process.id, fieldToUpdate).then((response2) => {
                      if (!response2 || !response2.data) {
                        return;
                      }
                      Vue.toasted.success(response2.data.message, { position: "top-right", duration: 6000 });
                      const updated = response2.data.data;
                      if (updated) {
                        if (fieldToUpdate === "status") {
                          this.broadcastProcessUpdate(process.id, {
                            statusLastModifiedBy: updated.statusLastModifiedBy,
                            statusDateOfLastModify: updated.statusDateOfLastModify,
                          });
                        }
                        if (fieldToUpdate === "operationStatus") {
                          this.broadcastProcessUpdate(process.id, {
                            operationStatusLastModifiedBy: updated.operationStatusLastModifiedBy,
                            operationStatusDateOfLastModify: updated.operationStatusDateOfLastModify,
                          });
                        }
                      }
                      this.checkProcessEvents(process.id, fieldToUpdate, this.data.identification);
                    });
                  }

                  this.showFieldUpdated(oldValue, newValue);
                }
              })
              .catch((error) => {
                Swal.fire(
                  "Atualização do Processo Nº ",
                  `Não foi possível atualizar o campo  ${this.fieldInfo.label} de <strong>${oldValue}</strong> para <strong>${formValues}</strong>. <br /><br />${error.response.data.message}`,
                  "error"
                );
              });
          }
        }
      } else {
        Swal.fire(
          `Atualização do Processo Nº ${this.data.identification}`,
          `O campo <strong>${this.fieldInfo.label}</strong> não está habilitado para ser editado.`,
          "warning"
        );
      }
    },
  },
};
</script>

<style>
@import "../../../assets/css/desk.css";
</style>

<style lang="scss" scoped>
td {
  &:hover {
    cursor: default;
    background: #f4f4f4;
  }

  &.btn-dribbble {
    background-color: #800080;
    color: #fff;
  }

  &.btn-red {
    background-color: #dc3545;
    color: #fff;
  }

  &.btn-green {
    background-color: #23bf08;
    color: #fff;
  }

  &.btn-yellow {
    background-color: #f49917;
    color: #fff;
  }

  &.btn-sky {
    background-color: #77c4e2;
    color: #fff;
  }

  &.btn-redlight {
    background-color: #ff5f5f;
    color: #fff;
  }

  &.btn-orange {
    background-color: #ff4500;
    color: #fff;
  }

  &.btn-slategray {
    background-color: #6c757d;
    color: #fff;
  }
}
</style>
